// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"454":"d4e77340","656":"0a15c722","993":"1bb1dcb8"}[chunkId] + ".chunk.js";
};